import { MaskedLines, Overline } from "./Reveal";
import { useLocation } from "react-router-dom";
import { useContent } from "../lib/content";

export default function PageHero({ overline, title, subtitle, image, testid }) {
  const { pathname } = useLocation();
  const cms = useContent();
  const defaultTitle = (Array.isArray(title) ? title : [title]).join("\n");
  const lines = cms(`${pathname}.hero.title`, defaultTitle).split("\n").filter((l) => l.trim());
  const ov = cms(`${pathname}.hero.overline`, overline || "");
  const sub = cms(`${pathname}.hero.subtitle`, subtitle || "");
  const img = cms(`${pathname}.hero.image`, image || "");

  return (
    <section data-testid={testid} className="relative overflow-hidden pt-40 pb-20">
      {img && (
        <div className="absolute inset-0">
          <img src={img} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-navy/85" />
        </div>
      )}
      <div className="absolute inset-0 gold-radial" />
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8">
        {ov && <Overline>{ov}</Overline>}
        <h1 className="mt-6 font-serif text-5xl leading-[0.98] tracking-tighter text-white md:text-6xl lg:text-7xl">
          <MaskedLines lines={lines} />
        </h1>
        {sub && <p className="mt-7 max-w-2xl text-lg leading-relaxed text-slate-300">{sub}</p>}
      </div>
    </section>
  );
}
